import React, { ReactNode } from 'react';
import Select, { Props as SelectProps } from 'react-select/async';
import debounce from 'lodash.debounce';

import styles from './styles';

interface OptionProps {
  value: string;
  label: ReactNode;
}

export interface AsyncSelectProps extends SelectProps<OptionProps, true> {}

function AsyncSelect(props: AsyncSelectProps) {
  const { loadOptions } = props;
  const debouncedLoadOptions = debounce(loadOptions, 500);
  const nextProps = {
    ...props,
    loadOptions: (value) => debouncedLoadOptions(value),
  };

  return <Select isMulti styles={styles} {...nextProps} />;
}

export default AsyncSelect;
